import { render, staticRenderFns } from "./RecipientDropdown.vue?vue&type=template&id=5bcf31f9&scoped=true&"
import script from "./RecipientDropdown.vue?vue&type=script&lang=js&"
export * from "./RecipientDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RecipientDropdown.vue?vue&type=style&index=0&id=5bcf31f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcf31f9",
  null
  
)

export default component.exports